import { s } from "../lib/constants";

export default function WaitingScreen({ sessionCode, person2Joined, onStart }) {
  return (
    <div style={s.step}>
      <p style={s.eyebrow}>session created</p>
      <p style={s.display}>Share this code<br />with the other person</p>
      <div style={styles.codeBox}>
        <span style={styles.codeText}>{sessionCode}</span>
      </div>
      <p style={s.body}>
        {person2Joined
          ? "✓ They've joined. You can start now."
          : "Waiting for them to join…"}
      </p>
      {person2Joined && (
        <button style={s.btnPrimary} onClick={onStart}>Start answering</button>
      )}
    </div>
  );
}

const styles = {
  codeBox: {
    background: "#131a14",
    border: "1px solid #2a3a2b",
    borderRadius: 12,
    padding: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  codeText: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "4rem",
    color: "#c8924a",
    letterSpacing: "0.4em",
    fontWeight: 300,
  },
};
